<template>

<core-filter-bar :with-scroll="true">

	<core-filter-bar-left>

		<core-filter-summary :count="count" noun="result" :maximum="maximum" :loading="loading" />

	</core-filter-bar-left>

	<core-filter-bar-right>

		<core-filter-text filter="ratings/text" />

		<core-filter-sort page="ratings" filter="ratings/sort" />
		
		<core-filter-panel filter="ratings" v-on:expandClick="onExpandClick" />

		<core-filter-layout page="ratings" filter="config/ratings/layout" />

		<core-filter-tags type="ratings" />

		<core-filter-presets type="ratings" />
		
		<core-filter-export type="ratings" />

	</core-filter-bar-right>

	<core-filter-advanced :active="is.expanded" filter="ratings" :has-reset="true" :has-advanced="true" v-on:reset="onResetClick" v-on:clickoutside="onOutsideClick">

		<template v-slot:inputs>

			<core-filter-advanced-inputs>

			<core-filter-input-text filter="ratings/text" :inline="true" />

			</core-filter-advanced-inputs>

			<core-filter-advanced-inputs>

			<core-filter-advanced-title>Ratings</core-filter-advanced-title>

			<app-filter-template-ratings-user filter="ratings" />

			<app-filter-template-ratings-group filter="ratings" />

			<app-filter-template-collection-community filter="ratings" />

			<app-filter-template-collection-comments filter="ratings" />

			<app-filter-template-common-tags filter="ratings" />

			<app-filter-template-common-tagfamilies filter="ratings" />

			</core-filter-advanced-inputs>

			<core-filter-advanced-inputs>

			<core-filter-advanced-title>Games</core-filter-advanced-title>

			<app-filter-template-games-general filter="ratings" />

			<app-filter-template-games-count filter="ratings" />
			
			<app-filter-template-games-include filter="ratings" />

			<app-filter-template-games-exclude filter="ratings" />

			</core-filter-advanced-inputs>

			<core-filter-advanced-inputs>

			<core-filter-advanced-title>Collection</core-filter-advanced-title>

			<app-filter-template-collection-general filter="ratings" />

			</core-filter-advanced-inputs>

			<core-filter-advanced-inputs>

			<core-filter-advanced-title>Plays</core-filter-advanced-title>

			<app-filter-template-ratings-plays filter="ratings" :range="true" />

			</core-filter-advanced-inputs>

			<core-filter-advanced-inputs>

			<core-filter-advanced-title>Other</core-filter-advanced-title>

			<app-filter-template-common-users filter="ratings" />

			<app-filter-template-common-designers filter="ratings" />
			
			<app-filter-template-common-artists filter="ratings" />
			
			<app-filter-template-common-publishers filter="ratings" />
			
			<app-filter-template-common-categories filter="ratings" />
			
			<app-filter-template-common-mechanics filter="ratings" />
			
			<app-filter-template-common-subdomains filter="ratings" />

			<app-filter-template-common-families filter="ratings" />

			</core-filter-advanced-inputs>

		</template>

	</core-filter-advanced>

	<app-filter-panel-tags type="ratings" />

</core-filter-bar>

</template>

<script>

export default {

	props: ['count', 'loading', 'maximum'],

	data: function() {

		return {

			is: {
				expanded: false
			}

		}

	},

	computed: {

		filter: function() {

			return this.$store.getters['filter/ratings']

		}

	},

	methods: {

		onExpandClick: function() {

			this.is.expanded = !this.is.expanded
			
			if (this.is.expanded) {

				this.$pubsub.$emit('filter.opened')

			}

		},

		onOutsideClick: function() {

			this.is.expanded = false

		},

		onResetClick: function() {

			this.$store.commit('filter/ratings/reset', {
				layout: this.filter.layout
			})

		}

	}

}

</script>

<style scoped>

.filter-text {
	font-size: 12px;
    display: block;
    color: #fff;
    font-weight: 400;
    padding-bottom: 8px;
}

.filter-search-mobile {
	margin: 4px 7px 0px 7px!important;
	width: calc(100% - 16px)!important;
}

@media only screen and (max-width: 767px) {

	.filter-section-first {
		margin-top: 4px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);
	}

}

</style>
